// /app/frontend/src/utils/analytics.js
// Tiny client-side tracker. Posts a pageview on every route change.
import axios from 'axios';

const KEY = 'mtk_anon_id';

function getAnonId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = 'anon_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return 'anon_no_storage';
  }
}

function readUtm() {
  try {
    const sp = new URLSearchParams(window.location.search);
    return {
      utm_source: sp.get('utm_source') || undefined,
      utm_medium: sp.get('utm_medium') || undefined,
      utm_campaign: sp.get('utm_campaign') || undefined,
    };
  } catch { return {}; }
}

let lastPath = null;

export async function trackPageview(pathname) {
  if (!pathname || pathname === lastPath) return;
  const prev = lastPath;
  lastPath = pathname;
  try {
    const token = localStorage.getItem('session_token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    await axios.post(`${window.location.origin}/api/analytics/track`, {
      anon_id: getAnonId(),
      path: pathname,
      referrer: document.referrer || '',
      ...readUtm(),
      screen_w: window.innerWidth,
      screen_h: window.innerHeight,
      event: 'pageview',
      prev_path: prev || '',
    }, { headers, timeout: 5000 });
  } catch {
    // Never let analytics break the app.
  }
}
